export default {
    url: 'wave-portable-air-conditioner',
    include: ['us', 'jp', 'ca', 'za', 'cn', 'au', 'sa'],
};
